import { Component, OnInit, TemplateRef } from '@angular/core';
import { UserService, CartService, ContextService, ArticlesService } from '../../services';
import { environment } from '../../../../environments/environment';
import { User, Panier, LignePanier } from '../../models';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Router, NavigationEnd } from '@angular/router';


@Component({
  selector: 'app-panier',
  templateUrl: './panier.component.html',
  styleUrls: ['./panier.component.scss']
})
export class PanierComponent implements OnInit {

  currentUser: User;
  isAuthed: boolean;
  context: string;
  context_route: string;

  imgfolder_url: string;
  panier: Panier;
  articles: Array<LignePanier>;
  nombre_articles: number;
  quantite_change: number;
  total: number = 0;

  loading: boolean = true;

  modalRef: BsModalRef;

  constructor(
  	private userService: UserService,
  	private articleService: ArticlesService,
  	private cartService: CartService,
  	private modalService: BsModalService,
  	private contextService: ContextService,
    private router: Router,
  ) { 
    this.nombre_articles=0;

   
  }

  ngOnInit() {  
    this.context = this.contextService.getContext();
    this.context_route = (this.context == 'B2C') ? '/familles' : '';
  	this.imgfolder_url = environment.imgfolder_url;

   this.router.events.subscribe((ev:any) => {
         if (ev instanceof NavigationEnd ) {
          let url =ev.url.split("/");
          this.context = (url[1] && url[1]=='familles') ? 'B2C':'B2B';
          this.context_route=(this.context=='B2B')?'':'/familles';
        
        }
          
     });

  	this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    );

    this.userService.isAuthenticated.subscribe(
    	(authData) => {
    		this.isAuthed = authData;
    	}
    );
    
    this.getCart();

     this.cartService.cartevent.subscribe(
      (data: any) => {
        if(data=='cartchange') this.getCart();
      });
    
  }


    getCart(){
      this.total = 0;
      this.nombre_articles= 0;
      this.articles = [];
      if(this.isAuthed){
          this.cartService.getUserCart().subscribe(
            data => {
              this.panier = data;
              this.processPanier()
              this.loading=false
            }
           );
      }else{
        this.panier = this.cartService.getLocalCart();
        this.processPanier()
        this.loading=false
       
      }
  }

  processPanier(){
    if(this.panier != null){
      this.articles=[];

      if(this.panier.lignePanier){
        this.articles = this.panier.lignePanier;
        this.nombre_articles = this.articles.length;
        this.articles.forEach(function (e){
          this.total += e.quantite * e.prixUnitaireTTC;
        }, this);
        this.total = this.total + this.panier.montantFraisDePort;
      } else {
        this.cartService.destroyLocalCart();
          this.nombre_articles = 0
      }
     /* if(this.isAuthed){
        this.total=this.panier.montantTotal;
      }*/
      


    }

  }


  openModal(template: TemplateRef<any>) {
    this.loading = true;
    this.getCart();
    this.modalRef = this.modalService.show(template);
  }

  hideModal(){
    this.modalRef.hide();
    this.cartService.cartevent.emit('cartchange');
    
  }

  updateLine(item: any){

  	this.cartService.updateLineFromLocalCart(item);  
    this.getCart();

  }

  removeFromCart(item: any){

  	this.cartService.deleteLineFromLocalCart(item);
  	this.getCart();

  }



}



// WEBPACK FOOTER //
// ./src/app/shared/user/_panier/panier.component.ts